import { Component, OnInit, Injectable, Input, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { PagedResult } from '../../../shared/model/generic-paged-result.model';
import { CeuService } from '../ceu.service';
import { CE_CreditType } from '../ce-credit-type.model';
import { AsyncState } from '../../../shared/model/index';
import {
  NumberValueAccessor,
  CreateNumberValueAccessorProvider,
  CreateNumberValueValidationProvider,
} from '../../../shared/widgets/value-accessors/number-value-accessor';
import { UtilService } from 'src/app/shared';

@Component({
  selector: 'wl-events-ceu-type-dropdown',
  templateUrl: 'ceu-type-dropdown.component.html',
  styleUrls: ['ceu-type-dropdown.component.css'],
  providers: [
    CreateNumberValueAccessorProvider(WlCeuTypeDropdownComponent),
    CreateNumberValueValidationProvider(WlCeuTypeDropdownComponent),
  ],
  standalone: false
})
export class WlCeuTypeDropdownComponent extends NumberValueAccessor implements OnInit {
  @Input() public required: boolean = false;
  @Input() public disabled: boolean = false;
  @Input() public inputCssClass: string = 'form-control';
  @Output() onCreditTypeChange: EventEmitter<CE_CreditType> = new EventEmitter<CE_CreditType>();

  /**
   * (readonly) are ceu types loading
   */
  public get loading(): boolean {
    return this._loadingState.busy;
  }

  /**
   * (readonly) are there any CEU Types?
   */
  public get errorLoadingCeuTypes(): boolean {
    return !this._loadingState.busy && !this._loadingState.success;
  }

  /**
   * (readonly) are there any CEU Types?
   */
  public get loadingCeuTypesErrorMessage(): string {
    return !this._loadingState.busy && !this._loadingState.success ? this._loadingState.message : '';
  }

  /**
   * (readonly) are there any CEU Types?
   */
  public get anyCeuTypes(): boolean {
    return !this._loadingState.busy && !this._ceuTypes;
  }

  public _ceuTypes: Array<CE_CreditType> = [];
  public _loadingState: AsyncState = new AsyncState();

  /**
   * construct
   * @param _ceuService
   */
  public constructor(public _ceuService: CeuService, public _utilService: UtilService) {
    super();
  }

  /**
   * when the component is initialized
   */
  ngOnInit() {
    this.loadCeuTypes();
  }

  /**
   * validity checker
   */
  public isValid = (): boolean => {
    return !this.required || this.value > 0;
  };

  /**
   * refresh the list
   */
  public refresh() {
    this.loadCeuTypes();
  }

  /**
   * load ceu types
   */
  public loadCeuTypes() {
    this._loadingState.busy = true;
    this._loadingState.success = false;
    this._loadingState.message = '';

    this._ceuService
      .getCeCreditTypes()
      .then((data) => {
        this._ceuTypes = data;
        this._loadingState.busy = false;
        this._loadingState.success = true;
      })
      .catch((error) => {
        this._loadingState.busy = false;
        this._loadingState.success = false;
        this._loadingState.message = this._utilService.extractErrorMessage(error);
      });
  }

  /**
   * triggered when the dropdown selection is changed
   * @param selected
   */
  public handleSelectChange(selected: CE_CreditType) {
    this.onCreditTypeChange.emit(selected);
  }
}
